<div class="modal-container">
    <div class="modal-header border-0 justify-content-center">
      <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
    </div>
    <div class="modal-body">
      <div class="text-center">
        <p class="m-0 text-light-gray primary-text my-auto">You are about to remove the link between
            <span class="as-active text-break text-primary-color text-uppercase font-12">
              {{data?.mpn}} | {{data?.mfr}}</span>.
           </p>
        <p class="m-0 text-light-gray primary-text pt-3">Are you sure you want to proceed?</p>
      </div>
    </div>
    <div class="modal-footer border-0 justify-content-center">
      <div class="m-0">
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info font-11'" class="me-3" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-primary font-11'" class="ms-3" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.CONFIRM" (click)="activeModal.close('Close click')"></app-button>
      </div>
    </div>
  </div>
